/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import Switch from '@material-ui/core/Switch';

const HackthonToggle = ({ isAdmin, isHackthonEnabledProps, postIsHackathonDomainServiceFn, classes , handleIsHackthonTrueAndFalse}) => {
  // console.log("🚀 ~ HackthonToggle ~ isHackthonEnabledProps:", isHackthonEnabledProps)
  const handleToggle = () => {
    if (isAdmin) {
      postIsHackathonDomainServiceFn(!isHackthonEnabledProps);
    }
  };


  // useEffect(()=>{
  //   handleIsHackthonTrueAndFalse?.()
  // },[isHackthonEnabledProps])

  return (
    !isAdmin ? null :
    <fieldset className={classes.fieldsetBox}>
      <label htmlFor="isHackathon">isHackathon</label>
      <Switch
        name="isHackathon"
        id="isHackathon"
        inputProps={{ 'aria-label': ' checkbox' }}
        disabled={!isAdmin}
        checked={isHackthonEnabledProps}
        onChange={handleToggle}
      />
    </fieldset>

  );
};

export default HackthonToggle;
